import Sand from './imgs/sand.jpg';

const SandData = [
    {
        id:"1",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"2",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"3",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"4",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"5",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"6",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"7",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"8",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"9",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"10",
        imgsrc: Sand,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
];

export default SandData;